import { useEffect, useRef, useState } from "react";
import * as pdfjs from "pdfjs-dist";

pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.js", import.meta.url).toString();

// Page-by-page canvas rendering: no browser PDF toolbar, so no download/print control (REQ-357).
export const PdfCanvas = ({ blob, onError }) => {
  const box = useRef(null);
  const [pages, setPages] = useState(0);

  useEffect(() => {
    let cancelled = false;
    let doc = null;
    const el = box.current;
    (async () => {
      try {
        doc = await pdfjs.getDocument({ data: new Uint8Array(await blob.arrayBuffer()) }).promise;
        if (cancelled) return;
        setPages(doc.numPages);
        const width = Math.min(box.current?.clientWidth || 900, 1100) - 24;
        for (let n = 1; n <= doc.numPages && !cancelled; n += 1) {
          const page = await doc.getPage(n);
          const base = page.getViewport({ scale: 1 });
          const vp = page.getViewport({ scale: (width / base.width) * (window.devicePixelRatio || 1) });
          const canvas = document.createElement("canvas");
          canvas.width = vp.width;
          canvas.height = vp.height;
          canvas.style.width = `${width}px`;
          canvas.className = "mx-auto mb-3 block bg-white shadow";
          canvas.dataset.testid = `pdf-page-${n}`;
          await page.render({ canvasContext: canvas.getContext("2d"), viewport: vp }).promise;
          if (!cancelled) box.current?.appendChild(canvas);
        }
      } catch {
        if (!cancelled) onError();
      }
    })();
    return () => { cancelled = true; doc?.destroy(); if (el) el.innerHTML = ""; };
  }, [blob, onError]);

  return <div ref={box} className="h-full w-full overflow-auto p-3" data-testid="file-viewer-pdf" data-pages={pages} />;
};
